export default "<div  [id]=\"cmsContentId\" cmsContent></div>\r\n";